import axios from 'axios'

export const menus = {
  state: {
    mainMenu: [],
    teaserMenu: [],
    tripPlannerMenu: [],
  },

  mutations: {
    setMenus(state, menus) {
      const { mainMenu, teaserMenu, tripPlannerMenu } = menus

      state.mainMenu = mainMenu
      state.teaserMenu = teaserMenu
      state.tripPlannerMenu = tripPlannerMenu
    },

    clearMenus(state) {
      state.mainMenu = []
      state.teaserMenu = []
      state.tripPlannerMenu = []
    },
  },

  actions: {
    async fetchMenusFromApi({ getters, rootState, commit }) {
      commit('clearMenus')

      const { locale } = rootState

      try {
        const response = await axios({
          method: 'GET',
          url: `${getters.menuEndpoint}/${locale}`,
        })

        commit('setMenus', response.data)
        commit('clearMenuError')
      } catch (err) {
        console.log('err', err)
        commit('setMenuError', 'errors.menu')
      }
    },
  },

  getters: {
    menuEndpoint(state, getters, rootState) {
      return `${rootState.apiEndoint}/menus`
    },
  },
}
